import reducer from './reducer'

import * as contactsOperations from './operations'
import * as contactsSelectors from './selectors'

export { contactsOperations, contactsSelectors }

export default reducer
